/*
パララックス　

親要素のidをコンストラクタで受け取り、
子要素の.plx-targetをパララックスで動かす

*1 .plx-targetの高さをcss上であらかじめ大きめにしておく(親要素を超える高さにしておく)
*2 親要素と.plx-targetの高さの差を計算して動かすため、親要素と.plx-targetの高さが同じだと動かない
*3 .plx-targetをtranslateYで動かすため、他のtransform要素を設定している場合は注意
*4 delaySpeedで動きの遅延速度を設定できる（1で遅延なし）

*/
class Plx {


  private plxContainer:HTMLElement;
  private plxTarget:HTMLElement;

  private targetY:number=0;
  private Y:number=0;
  private vect:number=-0.5;
  private delaySpeed:number=1;

  private minY:number = -3000;
  private maxY:number = 3000;

  constructor(_id:string,_delaySpeed:number=1){

    this.delaySpeed = _delaySpeed;

    this.plxContainer = document.getElementById(_id);
    this.plxTarget = this.plxContainer.querySelector('.plx-target') as HTMLElement;

    this.setVect();
    this.init();
    this.startAnim();
  }

  setVect(){

    let plxContainerHeight:number = this.plxContainer.clientHeight;
    let plxTargetHeight:number = this.plxTarget.clientHeight;

    let heightDiff:number = plxTargetHeight - plxContainerHeight;
    let plxDistance:number = window.innerHeight;

    //this.vect = -1 * heightDiff / plxDistance;
    this.vect = -1 * (heightDiff / window.innerHeight);
  }

  init(){

    window.addEventListener('scroll',(e)=>{

      let rect = this.plxContainer.getBoundingClientRect();
      
      this.targetY = rect.top * this.vect;

      //console.log(this.targetY)
  
    });

    window.addEventListener('resize',(e)=>{

      this.setVect();
    })
  }

  startAnim(){

    const setPlx = ()=>{

      this.Y += (this.targetY - this.Y)/this.delaySpeed;

      this.Y = Math.min(this.maxY,Math.max(this.minY,this.Y));
  
      this.plxTarget.style.transform = `translateY(${this.Y}px)`;
  
      window.requestAnimationFrame(setPlx);
    }
  
    window.requestAnimationFrame(setPlx);
  }

}

export default Plx;

